"use strict";

import Cookies from "js-cookie";

window.Cookies = Cookies;
